import * as React from 'react';

type ContentLayoutProps = {
  children: React.ReactNode;
  title?: string;
  description?: string;
};

const ContentLayout = ({
  children,
  title,
  description,
}: ContentLayoutProps) => {
  return (
    <>
      <div className='p-8 overflow-y-scroll h-[calc(100vh-72px)]'>
        <div className='mx-auto max-w-7xl px-4 sm:px-6 md:px-8'>
          {title && <h2 className='text-gray-900'>{title}</h2>}
          {description && (
            <h4 className='text-[#666] mt-2 ml-1'>{description}</h4>
          )}
        </div>
        <div className='mx-auto max-w-7xl px-4 py-6 sm:px-6 md:px-8 mt-4'>
          {children}
        </div>
      </div>
    </>
  );
};

export default ContentLayout;
